import { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
// Import Components
import { CJInfoBlockLabelValueWrapper } from 'components/CustomerJourney/infoBlocks';
// Import Services
import { Helpers } from 'services';
// Import Hooks
import { usePartnerDateFormats } from 'hooks/UsePartnerDateFormats';
// Import Constants
import { l } from 'constants/common';

const { customMoment } = Helpers;

const CJDTDateTimeInfoBlock = ({ data }) => {
    const { t } = useTranslation();
    const { partnerDateTimeWithoutSecondsFormat } = usePartnerDateFormats();
    const { dates, months, years, hours, minutes } = data?.value?.params ?? {};
    const date = customMoment()
        .set('year', years)
        .set('month', months)
        .set('date', dates)
        .set('hour', hours)
        .set('minute', minutes);

    return (
        <CJInfoBlockLabelValueWrapper label={t(l.DateTime)} value={date.format(partnerDateTimeWithoutSecondsFormat)} />
    );
};

CJDTDateTimeInfoBlock.propTypes = {
    data: PropTypes.object.isRequired,
};

export default memo(CJDTDateTimeInfoBlock);
